// extracted by mini-css-extract-plugin
module.exports = {"body":"ButtonLogin_body__2Y0Kv"};